import { AloftArea, PairedCostFeatures, isUndefined } from '@aloft/toolkit-shared';

import { PublicRecords } from '../../../../controller/types.ts';
import { getMarketLandToValueRatio } from '../../../referenceView/utils/getMarketLandToValueRatio.ts';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../../types.ts';

const getSiteToValueRatioFromFeatures = (features?: PairedCostFeatures) => {
  // siteSize for sorting
  const siteSize = features?.site?.siteValue?.sqft.toSqFt().getUnitAmount();
  const siteToValueRatio = features?.site?.siteToValueRatio;
  return { siteToValueRatio, siteSize };
};

const getSiteToValueRatioFromPublicRecords = (id: string, publicRecords?: PublicRecords) => {
  if (isUndefined(publicRecords)) return {};
  const publicRecord = publicRecords[id];
  const marketLandToValueRatio = getMarketLandToValueRatio(publicRecord) ?? undefined;
  return { marketLandToValueRatio };
};

export const getSiteToValueRatioChartData = (
  props: Tkv2PairedCostSummaryInterfaceV2 | null,
  publicRecords: {
    isLoading: boolean;
    data?: PublicRecords | undefined;
  },
  compSequence: string[] | undefined,
  siteSizes: Record<string, AloftArea | undefined>,
  siteToValueRatios: Record<string, number | undefined>,
) => {
  const data: {
    siteName: string;
    siteSize: number | undefined;
    siteToValueRatio: number | undefined;
    marketLandToValueRatio?: number | undefined;
  }[] = [];

  if (props) {
    const subjectFeatures = props.results?.subject?.features;
    data.push({
      siteName: 'SUB',
      ...getSiteToValueRatioFromFeatures(subjectFeatures),
      ...getSiteToValueRatioFromPublicRecords('subject', props.publicRecords.data),
    });

    props.compSequence.forEach((compId, idx) => {
      const compFeatures = props.results.comps[compId]?.features;
      data.push({
        siteName: `CP${idx + 1}`,
        ...getSiteToValueRatioFromFeatures(compFeatures),
        ...getSiteToValueRatioFromPublicRecords(compId, props.publicRecords.data),
      });
    });
  } else if (compSequence) {
    data.push({
      siteName: 'SUB',
      siteSize: siteSizes['subject']?.toSqFt().getUnitAmount(),
      siteToValueRatio: siteToValueRatios['subject'],
      ...getSiteToValueRatioFromPublicRecords('subject', publicRecords.data),
    });

    compSequence.forEach((compId, idx) => {
      data.push({
        siteName: `CP${idx + 1}`,
        siteSize: siteSizes[compId]?.toSqFt().getUnitAmount(),
        siteToValueRatio: siteToValueRatios[compId],
        ...getSiteToValueRatioFromPublicRecords(compId, publicRecords.data),
      });
    });
  }

  return data.sort((a, b) => (a.siteSize ?? 0) - (b.siteSize ?? 0));
};
